import React from 'react'
import Header from '../../component/Header'
import AboutUs from '../AboutUs'
import Footer from '../../component/Footer'
import CourseMA from '../CourseMA'

export default function LayoutCourseMA() {
    return (
        <div>
            <Header />
            <CourseMA />
            <Footer />
        </div>
    )
}
